
import '../../../assets/css/Text.css'
import React, { Children } from 'react'

interface IHeaderTitle {
    title: string;
    children?: React.ReactNode;
    className?: string;
}

const CounterTotalCatalog: React.FC<IHeaderTitle> = ({ title, children, className }) => {
    return (
        <div className={`flex justify-between items-center self-stretch px-6 gap-[0.625rem] relative ${className}`} >
            <h5 className={`${className} text-base font-decimal`}>
                {title}
            </h5>
            {Children.map(children, (child, index) => (
                <div className="Row" key={index}>
                    {child}
                </div>
            ))}
        </div>
    )
}

export default CounterTotalCatalog